import { Checkbox } from "primereact/checkbox"
import { classNames } from "primereact/utils"
import { Controller } from "react-hook-form"

interface ICheckbox {
    label: string,
    name: string,
    control: any,
    error?: string,
    required?: boolean,
    showEmptyLabelAtTop?: boolean,
    column?: number,
    disabled?: boolean,
    className?: string   // add this
}


export const JVCheckbox = (props: ICheckbox) => {
    const className = props.column ? `field col-12 md:col-${12 / props.column}` : "field col-12 md:col-6";
    return (
        <div className={className}>
            {props.showEmptyLabelAtTop && <div className="mt-3">&nbsp;</div>}
            {props.required && <label htmlFor={props.name}>{props.label}<span style={{ color: 'red' }}>*</span></label>}
            <div className="flex align-items-start gap-2 mt-4"> {/* This line aligns the checkbox properly */}
                <Controller
                    name={props.name}
                    control={props.control}
                    render={({ field, fieldState }) => (
                        <Checkbox
                            {...field}
                            disabled={props.disabled}
                            checked={field.value}
                            className={classNames({ 'p-invalid': fieldState.invalid })}
                        />
                    )}
                />
                <label htmlFor={props.name} className="mt-1">{props.label}</label> {/* Use mt-1 to align text vertically */}
            </div>
        </div>
    );
}